import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import { getBaseUrl } from '../utils/globals';
import RouterLink from './RouterLink';

export { Helmet };

type IfProps = {
  test: boolean;
};
/** Only render the child content if the test prop is truthy */
export const If: React.FC<IfProps> = ({ children, test }) => {
  if (test) return <>{children}</>;
  return null;
};

/** Only render the child content if the test prop is falsy */
export const IfNot: React.FC<IfProps> = ({ children, test }) => {
  if (!test) return <>{children}</>;
  return null;
};

type HTMLProps = {
  children: string;
} & JSX.IntrinsicElements['div'];

/** Pass a string in as children and it will render to unescaped HTML */
export const HTML: React.FC<HTMLProps> = ({ children, ...props }) => {
  return <div {...props} dangerouslySetInnerHTML={{ __html: children }} />;
};

type HomeLinkProps = { className?: string };
/** A link to the home page */
export const HomeLink: React.SFC<HomeLinkProps> = ({ children, className }) => {
  const baseUrl = getBaseUrl();
  return (
    <RouterLink to={baseUrl} className={className} data-testid="home-link">
      {children}
    </RouterLink>
  );
};

type ExtraPageLinkProps = { className?: string; path: string };
/** A link to any extra routes you define
 * NOTE: the current language will be automatically pre-pended
 */
export const ExtraPageLink: React.SFC<ExtraPageLinkProps> = ({
  children,
  className,
  path,
}) => {
  const baseUrl = getBaseUrl();
  return (
    <RouterLink to={`${baseUrl}/${path}`} className={className}>
      {children}
    </RouterLink>
  );
};
